import { createBrowserRouter } from "react-router-dom";
import adminRoutes from "./AdminRoutes";
import collageRoutes from "./CollageRoutes";
import studentRoutes from "./StudentRoutes";
import NotFound from "../pages/NotFound";


const router=createBrowserRouter([
    ...studentRoutes,
    ...adminRoutes,
    ...collageRoutes,
    {
        path: "/*",
        element:<NotFound/>
    }
])

export default router